import { getStores } from '@app/api/stores';
import { useCompany } from '@app/hooks/general/useCompany';
import { Store } from '@app/types/store';
import { snakeToCamelCase } from '@app/utils/snakeCamelTransform';
import { useQuery } from '@tanstack/react-query';

const GET_CONNECT_STORES_ACTIVE_QUERY = 'GET_CONNECT_STORES_ACTIVE_QUERY';

export function useConnectedStoresQuery() {
  const company = useCompany();
  return useQuery<Store[]>({
    queryKey: [GET_CONNECT_STORES_ACTIVE_QUERY],
    queryFn: async () => {
      const stores = await getStores({ companyId: company.id });
      return stores
        .filter(({ platform }) => platform.name !== 'API' && platform.actions.get_orders)
        .map(snakeToCamelCase);
    },
    cacheTime: Infinity,
  });
}
